import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../services/productservice';
import { AuthDialogService } from '../../services/auth-dialog.service';

@Component({
  selector: 'app-user-activation',
  templateUrl: './user-activation.component.html',
  styleUrls: ['./user-activation.component.scss'],
})
export class UserActivationComponent implements OnInit {
  verifiationFailed = false;

  constructor(private productService: ProductService, private authDialogService: AuthDialogService) {}

  ngOnInit(): void {
    this.productService.activateUser(location.search).then((res) => {
      if (!res.success) {
        this.verifiationFailed = true;
      }
      // Show login dialog after activation (matching legacy behavior)
      this.authDialogService.setVerificationFailed(true);
      this.authDialogService.openLoginDialog();
    });
  }
}
